export default __webpack_public_path__ + "static/media/bags_big.b4a90b17.jpg";